// Module
var code = "<bringoz-button class=\"copy-btn\" (on-click)=\"$ctrl.copyToClipboard(); $event.stopPropagation()\" type=\"tertiary\"> <bringoz-icon layout-align=\"start center\" icon-name=\"copy\" class=\"copy-icon\" aria-label=\"Copy\"></bringoz-icon> </bringoz-button> ";
// Exports
export default code;